// ** React Imports
import { Fragment, useEffect, useContext, useState } from 'react'
import { useIntl } from "react-intl"
import { Badge, Media, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useReactOidc } from "@axa-fr/react-oidc-context"
import { Bell } from 'react-feather'

// ** Third Party Components
import classnames from 'classnames'
import { findNotifications, deleteNotifications } from '@services/NotificationService'
import { IntlContext } from "@src/utility/context/Internationalization"
import { getValueConfig } from "@services/SystemParameterService"
import Jitsi from '../../../../views/jitsi/Jitsi'

const NotificationDropdown = () => {
  const intlContext = useContext(IntlContext)
  const { oidcUser } = useReactOidc()
  const [notifications, setNotifications] = useState([])
  const [timeCurrent, setTimeCurrent] = useState("")
  const [valueTime, setValueTime] = useState("")
  const [fetching, setFetching] = useState(true)

  const intl = useIntl()

  const headers = {
    Authorization: `Bearer ${oidcUser && oidcUser.access_token}`,
    "Accept-Language": intlContext.locale
  }

  useEffect(() => {
    if (fetching) {
      findNotifications(headers)
        .then((res) => {
          if (res) {
            setNotifications(res.data)
            setFetching(false)
          }
        })

      getValueConfig(headers, { code: "time-expire-call-verify" })
        .then((res) => {
          setValueTime(res?.data)
        })
    }
  }, [fetching])

  useEffect(() => {
    const timeCheck = setInterval(() => {
      const today = new Date()
      const mm = today.getMinutes() < 10 ? `0 ${today.getMinutes()}` : `${today.getMinutes()}`
      const ss = today.getSeconds() < 10 ? `0 ${today.getSeconds()}` : `${today.getSeconds()}`
      var time = today.getHours() + ":" + mm + ":" + ss
      var array = time.split(":");
      var seconds = (parseInt(array[0], 10) * 60 * 60) + (parseInt(array[1], 10) * 60) + parseInt(array[2], 10)
      setTimeCurrent(seconds)
    }, 1000);

    return () => clearInterval(timeCheck)
  }, [timeCurrent])

  const actionAccept = (value) => {
    window.open(`${value}`)
  }

  const actionOnclick = (value) => {
    const myWindow = window.open("https://stg-meet.cyberid.vn/cyberid", "", "width=1,height=1,left=10000,top=10000")
    setTimeout(() => {
      myWindow.close()
      window.open(`${value}`)
    }, 3000)
  }

  const formatTime = (dateTime, id) => {
    const time = dateTime.split(" ")
    var array = time[1].split(":")
    var seconds = (parseInt(array[0], 10) * 60 * 60) + (parseInt(array[1], 10) * 60) + parseInt(array[2], 10)
    if (timeCurrent - seconds >= valueTime * 60) {
      deleteNotifications(headers, id)
        .then((res) => {
          setFetching(true)
        })
    }
  }

  return (
    <UncontrolledDropdown tag='li' className='dropdown-notification nav-item mr-25'>
      <DropdownToggle tag='a' className='nav-link' href='/' onClick={e => e.preventDefault()}>
        <Bell size={21} />
        <Badge pill color='danger' className='badge-up'>
          {notifications.length}
        </Badge>
      </DropdownToggle>
      <DropdownMenu tag='ul' right className='dropdown-menu-media mt-0'>
        <PerfectScrollbar
          component='li'
          className='media-list scrollable-container'
          options={{
            wheelPropagation: false
          }}
        >
          {notifications.map((item) => (
            <div key={item?.id} className='d-flex' onClick={e => e.preventDefault()}>
              <Media
                className={classnames('d-flex')}
              >
                <Fragment>
                  <Media body>
                    <Media tag='div' heading>
                      <div className='font-weight-bolder'>
                        {item?.title}
                        {item?.acceptUrl && (
                          <div>
                            <a href={item?.acceptUrl} onClick={() => actionAccept(item?.acceptUrl)}>{intl.formatMessage({ id: "accept" })}</a>
                            / <a style={{ color: 'red' }} href={item?.refuseUrl} onClick={() => actionAccept(item?.refuseUrl)}>{intl.formatMessage({ id: "reject" })}</a>
                          </div>
                        )}
                        {item?.inviteCallUrl && (
                          <div>
                            <a href={item?.inviteCallUrl} onClick={() => actionOnclick(item?.inviteCallUrl)}>{item?.inviteCallUrl}</a>
                            <div>{item?.createdDate}{item?.createdDate ? formatTime(item?.createdDate, item?.id) : ""}</div>
                          </div>
                        )}
                      </div>
                    </Media>
                  </Media>
                </Fragment>
              </Media>
            </div>
          ))}
        </PerfectScrollbar>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default NotificationDropdown
